/* AZIONE DISTRUTTIVA A DUE TOCCHI.
 *
 * Sta in fondo alla schermata, dove arriva il pollice: sopra ci stanno i
 * numeri, che si leggono e basta.
 *
 * Perché due tocchi e non uno: un tocco solo la renderebbe premibile per
 * sbaglio in tasca. Perché non un menu: nasconderla la renderebbe irrecuperabile
 * proprio quando serve — fuori casa, quando qualcosa non va.
 * Perché si disarma da sola dopo tre secondi: un pulsante rimasto armato è un
 * pulsante che verrà premuto per sbaglio dopo.
 */

import { useEffect, useRef, useState } from 'react';
import { IconaFerma } from './Base';

const SECONDI_ARMATA = 3;

export function AzioneDistruttiva({
  etichetta,
  etichettaArmata,
  nota,
  notaArmata = `si annulla da solo fra ${SECONDI_ARMATA} secondi`,
  onConferma,
  disabilitata = false,
}: {
  etichetta: string;
  etichettaArmata: string;
  /** Cosa succede davvero. "la posizione aperta resta, non viene liquidata". */
  nota: string;
  notaArmata?: string;
  onConferma: () => void;
  disabilitata?: boolean;
}) {
  const [armata, setArmata] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);

  function premi() {
    if (disabilitata) return;
    if (timer.current) clearTimeout(timer.current);

    if (armata) {
      setArmata(false);
      onConferma();
      return;
    }

    setArmata(true);
    timer.current = setTimeout(() => setArmata(false), SECONDI_ARMATA * 1000);
  }

  return (
    <div>
      <button
        type="button"
        className={`sb-distruttiva${armata ? ' sb-distruttiva--armata' : ''}`}
        onClick={premi}
        disabled={disabilitata}
        aria-live="polite"
      >
        <span className="sb-distruttiva__testo">{armata ? etichettaArmata : etichetta}</span>
        <span className="sb-distruttiva__pomello" aria-hidden="true">
          <IconaFerma />
        </span>
      </button>
      <div className="sb-distruttiva__nota">{armata ? notaArmata : nota}</div>
    </div>
  );
}
